import { Dispatch, SetStateAction } from "react";
import Input from "../../../../../components/Input";

interface IInputData {
  dateTo: Date | string;
  setDateTo: Dispatch<SetStateAction<Date | string>>;
  dateFrom: Date | string;
  setDateFrom: Dispatch<SetStateAction<Date | string>>;
  disabled?: boolean;
}

export default function InputData({ dateTo, setDateTo, dateFrom, setDateFrom, disabled = false }: IInputData) {
  return (
    <>
      <Input
        className="Input-filter-hours-management"
        name="dateFrom"
        label="Data Inicial"
        placeholder="dd/mm/aaaa"
        type="month"
        value={dateFrom}
        setValue={(e) => setDateFrom(e.target.value)}
        disabled={disabled}
      />
      <Input
        className="Input-filter-hours-management"
        name="dateTo"
        label="Data Final"
        placeholder="dd/mm/aaaa"
        type="month"
        value={dateTo}
        setValue={(e) => setDateTo(e.target.value)}
        disabled={disabled}
      />
    </>
  );
}
